import React, { useEffect } from 'react'
import { Trip } from '../../types'
import { useTranslation } from 'react-i18next'
import { AppDispatch, RootState } from '../../store';
import { useDispatch, useSelector } from 'react-redux';
import Reviews from '../ui/Reviews';
import { fetchTripReviews } from '../../features/admin/tripSlice';
const TripDetails = ({ trip }: { trip: Trip }) => {
  const dispatch = useDispatch<AppDispatch>();
  const { reviews } = useSelector((state: RootState) => state.tripSlice);
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(fetchTripReviews(trip.id));
  }, [dispatch, trip.id])
  return (
    <div>
      <div className=''>
        <h4 className=' text-lg font-semibold mb-2'>{t("description")}</h4>
        <p className=' text-textSecond md:w-2/3 xs:w-full'>{trip.details}</p>
      </div>
      <div className=' mt-5'>
        <Reviews reviews={reviews} />
      </div>
    </div>
  )
}

export default TripDetails